export function KMXOrganization(): boolean {
  const windowURL = window.location.pathname.includes('/kare-mobile');
  return windowURL;
}
